/* __next_internal_client_entry_do_not_use__ Tooltip auto */ import { _buildTooltip, _buildTinyTooltip } from "./common";
export function Tooltip(props) {
    var tinyTooltipProps = props;
    if (tinyTooltipProps.tiny) {
        return _buildTinyTooltip(props);
    }
    return _buildTooltip(props, false);
}
